import { render, staticRenderFns } from "./ClustersPage.vue?vue&type=template&id=dfa25f2a&scoped=true&"
import script from "./ClustersPage.vue?vue&type=script&lang=js&"
export * from "./ClustersPage.vue?vue&type=script&lang=js&"
import style0 from "./ClustersPage.vue?vue&type=style&index=0&id=dfa25f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa25f2a",
  null
  
)

export default component.exports